import { render, staticRenderFns } from "./stripe_instant_balance.vue?vue&type=template&id=b8f20662&"
import script from "./stripe_instant_balance.vue?vue&type=script&lang=js&"
export * from "./stripe_instant_balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports